import React, { useEffect, useState } from "react";
import "../../Opportunities/CardTabs/BattleCard.css";
import ThemedCardComponent from "../../../genericComponents/themedCardCompoennt";
import { useWebSocket } from "../../../uiUtils/useWebSocket";
import { useDispatch, useSelector } from "react-redux";
import { fetchBattleCardMpRequest } from "../../../../../store/features/actions/meetingPrep/battleCardActions";
import { useParams } from "react-router-dom";
import NoDataComp from "../../../genericComponents/uiElements/NoDataComp";
import { ValueSellingFrameworkPlaceholder } from "../../Opportunities/CardTabs/ValueSellingFramworkPlaceholder";
import * as FeatherIcon from "react-feather";
import { fetchAccountInfo } from "../../../../../services/accIqService";
import { formatDateForRecentDevelopments, numberWithCommas, smartDecimalNumberFormatter } from "../../../../../services/commonService";
import { fetchAccPlanPositiveNegative } from "../../../../../services/iqApiV2";
import RenderHtmlFormattedText from "../../../../HtmlElements/RenderHtmlFormattedText";
import { COMPANY_LOGO_BASE_URL } from "../../../../../config/apiConfig";
import APP_CONFIG from "../../../../../config/appConfig";

function replaceUnderSquarebySpace(word) {
  return word
    ?.replace(/[_\[\]]/g, " ") // Replace underscores and square brackets with space
    .replace(/\s+/g, " ") // Normalize multiple spaces to single space
    .trim() // Remove leading/trailing spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
}

export default function MeetingPrepBattleCard({ opportunityId, selectedOpportunity }) {

  // console.log("selectedOpportunity : ", selectedOpportunity)

  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const [status, setStatus] = useState("Processing...");
  const [result, setResult] = useState(null);
  const { battleCardMpData, battleCardLoading, error } = useSelector(
    (state) => state?.battleCardMpReducer
  );

  const company_name = selectedOpportunity?.account_details?.account_name || ''
  const client_name = selectedOpportunity?.account_details?.client_name || ''
  const account_id = selectedOpportunity?.account_details?.account_id || ''

  console.log("selectedOpportunity?.account_details : ", selectedOpportunity?.account_details)

  const [account_info, setAccountInfo] = useState([]);
  const [recentDevelopmentsData, setRecentDevelopmentsData] = useState([]);
  const [positive_negative_data, setPositiveNegativeData] = useState({})
  const [isLogoLoading, setLogoLoading] = useState(true);
  const [showAllPositives, setShowAllPositives] = useState(false);
  const [showAllConcerns, setShowAllConcerns] = useState(false);
  const MAX_VISIBLE = 3;

  const positives = positive_negative_data?.top_positives || [];
  const concerns = positive_negative_data?.top_concerns || [];

  const visiblePositives = showAllPositives ? positives : positives.slice(0, MAX_VISIBLE);
  const visibleConcerns = showAllConcerns ? concerns : concerns.slice(0, MAX_VISIBLE);

  useEffect(() => {
    if (opportunityId) {
      dispatch(fetchBattleCardMpRequest({ opportunityId }));
    }
  }, [opportunityId]);

  useEffect(() => {
    if (error) {
      setStatus("Error loading data");
    } else {
      if (battleCardMpData) {
        delete battleCardMpData?._id;
        delete battleCardMpData?.opportunity_id;

        // console.log("battleCardMpData : ", battleCardMpData);

        // Unset key if no data present
        /*
        for (const key in battleCardMpData) {
          const value = battleCardMpData[key];
          if (
            value === null ||
            value === undefined ||
            (Array.isArray(value) && value.length === 0) ||
            (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
          ) {
            delete battleCardMpData[key];
          }
        }
        */
        // End: Unset key if no data present
      }
      setResult(battleCardMpData || []);
      setStatus("Completed!");
    }
  }, [battleCardMpData, error]);

  useEffect(() => {
    if (opportunityId) {
      const getCompanyDetailsInfo = async (client, company_name) => {
        
        try {
          // Set Recent Development Data
          const response = await fetchAccountInfo(company_name);
          let result = response ?? [];
          setAccountInfo(result);
          // console.log("result :: ", result)
          let recentDevelopmentsData = result?.key_developments?.results || [];
          recentDevelopmentsData = recentDevelopmentsData.filter((r) => r?.is_trending);
          setRecentDevelopmentsData(recentDevelopmentsData);
          // End: Set Recent Development Data

          // Set Positive Negative Data
          let positive_negative_data = await fetchAccPlanPositiveNegative(client, company_name);
          positive_negative_data = positive_negative_data ?? [];
          setPositiveNegativeData(positive_negative_data)
          // End: Set Positive Negative Data

        } catch (error) {
          console.error("Error in getCompanyDetailsInfo:", error);

          // Optionally reset or set fallback states
          setAccountInfo([]);
          setRecentDevelopmentsData([]);
          setPositiveNegativeData([]);
      }

        // console.log("positive_negative_data : ", positive_negative_data)

      };
      getCompanyDetailsInfo(client_name, company_name);




    }
  }, [opportunityId]);

  function generateCardContent(content) {
    if (!content) return null;

    const formatKey = (key) =>
      key
        .replace(/_/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, (char) => char.toUpperCase());

    const renderValue = (value, key = null) => {
      if (typeof value === "string") {
        return (
          <div key={key || value} className="row">
            {key && (
              <div className="col-md-4">
                <p className="opp_bat_para">
                  {key && (
                    <span className="opp_bat_span">{formatKey(key)}: </span>
                  )}
                </p>
              </div>
            )}

            <div className={`${!key ? "col-md-12" : "col-md-8 pl-0"} `}>
              <p className="opp_bat_para">{value}</p>
            </div>
          </div>
        );
      }

      if (Array.isArray(value)) {
        const hasObject =
          Array.isArray(value) &&
          value.some(
            (item) =>
              (item !== null && typeof item === "object") || key === null
          );

        return (
          <div key={key} className="battleCardListTop row">
            {key && (
              <span className="list_top_span col-md-4">{formatKey(key)}:</span>
            )}
            <ul
              className={`battleCardListUl ${
                hasObject ? "col-md-12 ml-2 pr-2" : "col-md-8"
              }`}
            >
              {value.map((item, idx) => (
                <li key={idx}>{renderValue(item)}</li>
              ))}
            </ul>
          </div>
        );
      }

      if (typeof value === "object") {
        return (
          <div key={key} style={{ marginBottom: "auto" }}>
            {key && <strong>{formatKey(key)}:</strong>}
            <div style={{ marginLeft: key ? "1em" : 0 }}>
              {Object.entries(value || {}).map(([childKey, childValue]) =>
                renderValue(childValue, childKey)
              )}
            </div>
          </div>
        );
      }

      return (
        <div key={key}>
          {key && <strong>{formatKey(key)}: </strong>}
          {String(value)}
        </div>
      );
    };

    return (
      <div className="">
        {typeof content === "string" ? (
          <div>{content}</div>
        ) : (
          renderValue(content)
        )}
      </div>
    );
  }

  return (
    <div className="battlecard_wrapper">
      {battleCardLoading == true || result === null ? (
        <div className="row w-100">
          <ValueSellingFrameworkPlaceholder
            numberOfCards={8}
            widthClass="col-md-6"
          />
        </div>
      ) : Object.keys(result).length === 0 ? (
        <div className="no-data-message">
          <NoDataComp
            message="Content is being generated"
            buttonText="Refresh"
            onButtonClick={() =>
              dispatch(fetchBattleCardMpRequest({ opportunityId }))
            }
          />
        </div>
      ) : (
        // <div className="row">
        // {
        //   Object.entries(result || {}).map(([key, value]) => (
        //     <div key={key} className="col-md-6">
        //       <div className="battle_card_block">
        //       <ThemedCardComponent
        //         title={replaceUnderSquarebySpace(key)}
        //         description={generateCardContent(value)}
        //       />
        //     </div>
        //     </div>
        //   ))
        // }
        // </div>

        <div className="row">
          {/* <div className="col-md-12">
        {
          Object.entries(result || {}).filter((_, index) => index % 2 === 0 || index % 2 === 1).map(([key, value]) => (
            <>
            {value && <div key={key} className="battle_card_block">
              <ThemedCardComponent
                title={replaceUnderSquarebySpace(key)}
                description={generateCardContent(value)}
              />
            </div>
            }
            </>
          ))
        }
      </div> */}

          <div className="col-md-12">
            <div className="meeting_prep_new_blocks">
              <div className="battle_card_block">
                <div className="battle_card_custom card">
                  <div className="battle_card_header card-header">
                    Agenda
                  </div>
                  <div className="battle_card_body card-body">
                    <div className="battle_content_block">
                      <div class="row">
                        <div class="col-md-12 pr-0 pl-0">
                          <div class="right_battle_content_block">
                            <div class="right_battle_content">
                              <div class="row mb-2">
                                <div class="col-md-4 pr-0">
                                  {" "}
                                  <strong>External Attendees :</strong>{" "}
                                </div>
                                <div class="col-md-8">
                                  <div className="attendees_list">
                                    {selectedOpportunity?.meta_data?.external_attendees && selectedOpportunity?.meta_data?.external_attendees.map((contact, index) => {
                                      return <span className="attendees_list_name pr-1">
                                        {contact?.name}
                                        {index < selectedOpportunity?.meta_data?.external_attendees.length - 1 ? ', ' : ''}
                                      </span>
                                    })}
                                  </div>
                                </div>
                              </div>
                              <div class="row mb-2">
                                <div class="col-md-4 pr-0">
                                  {" "}
                                  <strong>Internal Participants :</strong>{" "}
                                </div>
                                <div class="col-md-8">
                                  <div className="attendees_list">
                                    {selectedOpportunity?.meta_data?.attendees && selectedOpportunity?.meta_data?.attendees.map((contact, index) => {
                                      return <span className="attendees_list_name pr-1">
                                        {contact?.name}
                                        {index < selectedOpportunity?.meta_data?.attendees.length - 1 ? ', ' : ''}
                                      </span>
                                    })}
                                  </div>
                                </div>
                              </div>

                              <div class="row mb-2">
                                <div class="col-md-4 pr-0">
                                  {" "}
                                  <strong>Opportunity :</strong>{" "}
                                </div>
                                <div class="col-md-8">
                                  <div className="attendees_list">
                                    <span className="attendees_list_name pr-1">
                                      {result?.opportunity_data?.meeting_opportunity_title}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {result?.opportunity_data?.meeting_opportunity_recap && result?.opportunity_data?.meeting_opportunity_recap?.length > 0 && <div className="battle_card_block">
                <div className="battle_card_custom card">
                  <div className="battle_card_header card-header">Recap</div>
                  <div className="battle_card_body card-body">
                    <div className="battle_content_block">
                      <div class="row">
                        <div class="col-md-12 pr-0 pl-0">
                          <div class="right_battle_content_block">
                            <div class="right_battle_content">
                              
                              <div class="row mb-2">
                                {/* <div class="col-md-3 pr-0">
                                  {" "}
                                  <strong>Recap :</strong>{" "}
                                </div> */}
                                <div class="col-md-12">
                                  <div className="attendees_list">
                                    <div className="attendees_list_name pr-1">
                                      
                                      <ul className="three_points_ul custom_list_top">
                                        {result?.opportunity_data?.meeting_opportunity_recap.map((data_row, inx) => {
                                          return <li> {data_row}</li>
                                        })
                                        }
                                      </ul>
                                      
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* <div class="row mb-2">
                                <div class="col-md-3 pr-0">
                                  {" "}
                                  <strong>Related News:</strong>{" "}
                                </div>
                                <div class="col-md-9">
                                  <div className="attendees_list">
                                    {result?.opportunity_data?.recent_news && result?.opportunity_data?.recent_news?.map((news) => {
                                      return <p className="attendees_list_name pr-1">
                                        <strong>● {news?.news_title}</strong>
                                        <br />
                                        {news?.news_short_description}{" "}
                                      </p>
                                    })}
                                  </div>
                                </div>
                              </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }

              <div className="battle_card_block">
                <div className="battle_card_custom card">
                  <div className="battle_card_header card-header">
                    Customer Attendee Insights
                  </div>
                  <div className="battle_card_body card-body">
                    <div className="battle_content_block">
                      <div class="row">
                        <div class="col-md-12 pr-0 pl-0">
                          <div class="right_battle_content_block">
                            <div class="right_battle_content">

                              {result?.customer_attendee_insight && result?.customer_attendee_insight?.map((contact) => {
                                  return <div class="person-card-container">
                                    <div class="person-card-header ml-3">

                                      <div className="d-flex align-items-start justify-content-start">
                                        {/* <img
                                          src={contact?.photo_url}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "img/icons/contact.png";
                                          }}
                                        
                                          alt={contact?.contact_full_name}
                                          className="person-card-profile-pic"
                                          style={{
                                            height:'50px',
                                            width:'50px'
                                          }}
                                        /> */}

                                        <img
                                          className="avatar_img"
                                          src={APP_CONFIG.AVATAR_URL +"background=0D8ABC&color=fff&name=" + contact?.contact_full_name+ '&rounded=true&bold=true&font-size=0.50'}
                                          style={{
                                            height:'50px',
                                            width:'50px'
                                          }}
                                          alt="icon" />

                                        <div className="" style={{marginTop:"-5px"}}>
                                          <div class="person-card-info">
                                            <div className="ml-3">
                                              <h3 class="person-card-name">
                                                {contact?.contact_full_name}
                                              </h3>
                                              <p class="person-card-title">
                                                {contact?.contact_designation}
                                              </p>
                                              <p class="person-card-org custom_maker">
                                                {contact?.contact_label}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="">
                                      <ul className="three_points_ul custom_list_top">
                                          {contact?.contact_focus_area_and_kpi && <li>
                                          {contact?.contact_focus_area_and_kpi}
                                          </li>
                                          }
                                          {contact?.contact_role && <li>
                                            {contact?.contact_role}
                                          </li>
                                          }
                                          {contact?.contact_recent_update && <li>
                                            {contact?.contact_recent_update}
                                          </li>
                                          }
                                        </ul>
                                    </div>
                                    
                                  </div>
                                } 
                              )}
                              
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              

              <div className="battle_card_block">
                <div className="battle_card_custom card">
                  <div className="battle_card_header card-header">
                    Company Insights
                  </div>
                  <div className="battle_card_body card-body">
                    <div className="battle_content_block">
                      <div class="row">
                        <div class="col-md-12 pr-0 pl-0">
                          <div class="right_battle_content_block">
                            <div class="right_battle_content">
                              <div class="person-card-container">
                                <div class="person-card-header ml-3 ">
                                  {/* <img
                                    src="img/icons/contact.png"
                                    alt="Chitra Agarwal"
                                    class="person-card-profile-pic"
                                  /> */}
                                  <div className="d-flex align-items-start justify-content-start">
                                    {isLogoLoading && (
                                      <div className="baseSkeleton img-logo-banner-container"></div>
                                    )}{" "}
                                    {/* Loading skeleton for logo */}
                                    <a href={`/account_details/${account_id}/${encodeURIComponent(company_name)}/${encodeURIComponent(client_name)}`} target="_blank" >
                                    <img
                                      src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(
                                        company_name
                                      )}`}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = "img/icons/contact.png";
                                      }}
                                      alt=""
                                      height={'50'}
                                      width={'50'}
                                      aria-label="comapny logo img"
                                      className={`mr-2 ${
                                        isLogoLoading ? "hidden" : ""
                                      }`}
                                      style={{
                                        'border': '1px solid #ccc',
                                        'borderRadius': '50px',
                                        'padding': "5px"
                                      }}
                                      onLoad={() => setLogoLoading(false)}
                                    />
                                    </a>

                                    <div className="">
                                      <h3 class="person-card-name mb-0">
                                       <a href={`/account_details/${account_id}/${encodeURIComponent(company_name)}/${encodeURIComponent(client_name)}`} target="_blank" style={{color: '#27282D', textDecoration: 'none'}} > {company_name} </a>
                                      </h3>

                                      <div className="company_info_new">
                                      
                                      {account_info?.trbc_business_sector_name && <p class="person-card-title mr-3 d-flex align-items-center">
                                        <FeatherIcon.Aperture className="comp_icon pr-1" />{" "}
                                        <strong>Sector: </strong> {" "} {account_info?.trbc_business_sector_name}
                                      </p>
                                      }
                                      {account_info?.trbc_industry_name && 
                                      <p class="person-card-org mr-3 d-flex align-items-center">
                                        <FeatherIcon.Briefcase className="comp_icon pr-1" />{" "}
                                        <strong>Industry: </strong> {" "} 
                                        <span className="ml-1"> {account_info?.trbc_industry_name} </span>
                                      </p>
                                      }

                                      {account_info?.revenue &&
                                      <p class="person-card-org mr-3 d-flex align-items-center">
                                        <FeatherIcon.DollarSign className="comp_icon pr-0" />{" "}
                                        <strong>Revenue: </strong> {" "} 
                                        <span className="ml-1"> {numberWithCommas(smartDecimalNumberFormatter(account_info?.revenue))} Mn </span>
                                      </p>
                                      }

                                    </div>
                                    </div>

                                  </div>

                                </div>
                                <div class="person-card-info">
                                  <div className="ml-3 mb-3">
                                    {/* <p class="">
                                      <RenderHtmlFormattedText htmlContent={account_info?.business_description} />
                                    </p> */}

                                    <div className={`read-more-container expanded`}>
                                      <RenderHtmlFormattedText
                                        htmlContent={account_info?.business_description}
                                      />
                                    </div>
                                    {/* <span
                                      className="read-more-link"
                                      onClick={() => setExpanded(!expanded)}
                                    >
                                      {expanded ? "Read Less" : "Read More"}
                                    </span> */}
                                  </div>

                                  <div className="row">
                                    <div className="col-md-12 mb-1"><strong>Related News:</strong>{" "}</div>
                                    <div className="col-md-12">
                                      <div className="attendees_list ml-4">
                                        <ul className="three_points_ul custom_list_top">
                                        {result?.opportunity_data?.recent_news && result?.opportunity_data?.recent_news?.map((news) => {
                                          return <li><p className="attendees_list_name pr-1">
                                            <strong>
                                              <a href={news?.news_url} target="_blank" className="meeting_prep_news_link" >{news?.news_title}</a></strong>
                                            <br />
                                            {news?.news_short_description}{" "}
                                          </p></li>
                                        })}
                                        </ul>
                                      </div>
                                    </div>

                                  </div>

                                  {/* <div className="w-100 mb-3" style={{'clear': 'both'}}>
                                    
                                    {positives.length > 0 && <h5 className="common_head">
                                      <span className="highlights_content_dot highlights_content_green d-flex align-items-center"></span>
                                      Positives
                                    </h5>
                                    }
                                    <ul className="three_points_ul custom_list_top">
                                      {visiblePositives?.map((item, index) => (
                                        <li key={index}>{item}</li>
                                      ))}

                                      {positives.length > MAX_VISIBLE && (
                                        <div className="w-100 view-toggle text-primary cursor-pointer mt-2" >
                                          <span className="cursorP mb-3 mt-1" style={{'textDecoration': 'underline'}} onClick={() => setShowAllPositives(!showAllPositives)}>{showAllPositives ? "View Less" : "View More"}</span>
                                        </div>
                                      )}
                                    </ul>
                                  </div>
                                  
                                  
                                  <div className="w-100 mb-2" style={{'clear': 'both'}}>
                                    {concerns.length > 0 && <h5 className="common_head clearfix">
                                      <span className="highlights_content_dot highlights_content_red d-flex align-items-center"></span>
                                      Potential Concerns
                                    </h5>
                                    }

                                    <ul className="three_points_ul custom_list_top">
                                      {visibleConcerns?.map((item, index) => (
                                        <li key={index}>{item}</li>
                                      ))}

                                      {concerns.length > MAX_VISIBLE && (
                                        <div className="w-100 view-toggle text-primary cursor-pointer mt-2">
                                          <span className="cursorP" style={{'textDecoration': 'underline'}} onClick={() => setShowAllConcerns(!showAllConcerns)}>{showAllConcerns ? "View Less" : "View More"}</span>
                                        </div>
                                      )}
                                    </ul>
                                  </div> */}

                                  

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {false && <div className="battle_card_block">
                <div className="battle_card_custom card">
                  <div className="battle_card_header card-header">
                    Related News
                  </div>
                  <div className="battle_card_body card-body">
                    <div className="battle_content_block">
                      <div class="row">
                        <div class="col-md-12 pr-0 pl-0">
                          <div class="right_battle_content_block">
                            <div class="right_battle_content">

                              <div class="row mb-2">
                                <div class="col-md-12">
                                  <div className="attendees_list">
                                    {result?.opportunity_data?.recent_news && result?.opportunity_data?.recent_news?.map((news) => {
                                      return <p className="attendees_list_name pr-1">
                                        <strong>● 
                                          <a href={news?.news_url} target="_blank" style={{color: "#535458", textDecoration: 'none' }} >{news?.news_title}</a></strong>
                                        <br />
                                        {news?.news_short_description}{" "}
                                      </p>
                                    })}
                                  </div>
                                </div>
                              </div>


                              {/* {recentDevelopmentsData.map((development, index) => {
                                return   (<div class="person-card-container">
                                    <div class="person-card-header ml-3 d-flex align-items-center justify-content-start">
                                      <img
                                        src="img/fire.png"
                                        alt=""
                                        style={{height: '30px', width: "30px"}}
                                        class="person-card-profile-pic p-1 object-fit-contain mr-2"
                                      />
                                      <h3 class="person-card-name mb-0">
                                        {development.type}
                                      </h3>
                                    </div>
                                    <div class="person-card-info">
                                      <div className="ml-3 mb-2">
                                        <p class="">
                                          {development.headline}
                                        </p>
                                        <p class="">{formatDateForRecentDevelopments(development.date)}</p>
                                      </div>
                                    </div>
                                  </div>)
                              })} */}

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
